import { Component } from 'react';

// Fanger render-fejl så en ellers hvid skærm i stedet viser fejlteksten.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
    this.setState({ componentStack: info?.componentStack });
  }

  render() {
    if (!this.state.error) return this.props.children;
    const e = this.state.error;
    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 99999, overflow: 'auto',
        background: '#1a1a1a', color: '#f0f0f0',
        padding: '24px', fontFamily: 'monospace', fontSize: 13, lineHeight: 1.5,
      }}>
        <h2 style={{ color: '#ff6b6b', marginTop: 0 }}>App-fejl</h2>
        <p style={{ color: '#ffd' }}>{e?.message || String(e)}</p>
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#aaa', fontSize: 11 }}>
          {e?.stack || ''}
        </pre>
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#88a', fontSize: 11 }}>
          {this.state.componentStack || ''}
        </pre>
        <button onClick={() => { this.setState({ error: null }); }}
          style={{ marginTop: 16, padding: '10px 24px', background: '#4CAF82', color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer' }}>
          Prøv igen
        </button>
      </div>
    );
  }
}
